
import { useState } from 'react'
import './styles/acciones.css'

import PanelAcciones from '../components/acciones-components/PanelAcciones'
const Acciones=({server,dataGlobals,languaje,mode})=>{
    const [listSelected,setListSelected]=useState(1)
    const hadleChangeList=(e)=>{
        setListSelected(e)
    }
    return (
        <div className="main-cis">
            <PanelAcciones server={server}  mode={mode} languaje={languaje}/>
            
        </div>
    )
}

export default Acciones